export const useDisableSmoothScroll = () => {
    const disableSmoothScroll = () => {
        document.documentElement.style.scrollBehavior = 'initial';
        setTimeout(() => {
            document.documentElement.style.scrollBehavior = '';
        }, 1000); // needs delay to not immediately smooth scroll on the new page
    };

    return {
        disableSmoothScroll
    };
};
